export const RESOLVE_KEY = 'navigationBack'; // key is the same as the RESOLVE in navigation-back.resolve.ts

export interface INavigationBackResolveData {
  goBackUrl: string;
}
